import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-207e4fa4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "support-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Support", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Welcome to the Support page. We are here to help you with any questions, concerns, or feedback you might have.", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { id: "contact-form" }, "Contact Us", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("If you have specific questions, need personalised assistance, or just want to provide feedback and suggestions, please reach out to us through our contact email at "),
  /*#__PURE__*/_createElementVNode("a", { href: "mailto:refinementportal@gmail.com" }, "refinementportal@gmail.com"),
  /*#__PURE__*/_createTextVNode(". ")
], -1))
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_6))
}